"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _miniVirtualList = require("mini-virtual-list");
var _masonic = require("masonic");
var _size = require("../../hooks/size");
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _PromoItem = require("../ThreadFeedItem/PromoItem");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var COLUMN_COUNT = 2;
var GUTTER_SIZE = 20;
var PLACEHOLDER_PROMO = {
  type: 'PROMOT'
};
var MIN_FOOTER_HEIGHT = 183;
var ThreadFeedList = function ThreadFeedList(_ref) {
  var data = _ref.data,
    promo = _ref.promo,
    cards = _ref.cards,
    total = _ref.total,
    itemKey = _ref.itemKey,
    listRef = _ref.listRef,
    isLoaded = _ref.isLoaded,
    loadMore = _ref.loadMore,
    onScroll = _ref.onScroll,
    isLoading = _ref.isLoading,
    cellRenderer = _ref.cellRenderer,
    scrollToIndex = _ref.scrollToIndex,
    _ref$overscan = _ref.overscan,
    overscan = _ref$overscan === void 0 ? 1.3 : _ref$overscan,
    footer = _ref.footer;
  var showPromo = !(0, _isNil["default"])(promo);
  var bias = showPromo ? 1 : 0;
  var ref = {
    current: null
  };
  if (listRef.current) {
    ref = {
      current: listRef.current.querySelector('#masonry[role=grid]')
    };
  }
  // Masonry element width
  var _useSize = (0, _size.useSize)(ref),
    width = _useSize.width,
    innerHeight = _useSize.height;
  // Outer container height
  var _useSize2 = (0, _size.useSize)(listRef),
    height = _useSize2.height;
  var _useScroller = (0, _miniVirtualList.useScroller)(listRef),
    scrollTop = _useScroller.scrollTop,
    isScrolling = _useScroller.isScrolling;
  var dataRef = (0, _react.useRef)(data);
  var totalRef = (0, _react.useRef)(total);

  // Condition to update position caches
  // 1. Total is changed
  // 2. Loaded data is changed
  var shouldUpdateCache = (0, _react.useMemo)(function () {
    var prevData = dataRef.current;
    var prevTotal = totalRef.current;
    var cacheDependency = total;
    if (prevTotal === total) {
      var currLength = data.length;
      var prevLength = prevData.length;
      if (currLength === 0 && prevLength !== currLength) {
        cacheDependency = currLength;
      } else {
        var minLength = Math.min(currLength, prevLength);
        if (!(0, _isEqual["default"])(data.slice(0, minLength), prevData.slice(0, minLength))) {
          cacheDependency = currLength;
        }
      }
    }
    dataRef.current = data;
    totalRef.current = total;
    return cacheDependency;
  }, [data, total]);
  var positioner = (0, _masonic.usePositioner)({
    width: width,
    columnCount: COLUMN_COUNT,
    columnGutter: GUTTER_SIZE
  }, [shouldUpdateCache, total]);
  var resizeObserver = (0, _masonic.useResizeObserver)(positioner);
  var onLoadMore = (0, _masonic.useInfiniteLoader)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(startIndex, stopIndex) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadMore({
              startIndex: Math.max(0, startIndex - bias),
              stopIndex: stopIndex - bias
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    isItemLoaded: function isItemLoaded(index, items) {
      return index < bias ? true : isLoaded({
        index: index - bias
      });
    },
    minimumBatchSize: 10,
    threshold: 3,
    totalItems: total + bias
  });
  var RenderComponent = (0, _react.useCallback)(function (_ref3) {
    var _index = _ref3.index,
      data = _ref3.data,
      width = _ref3.width;
    var index = _index - bias;
    var style = {
      width: width,
      height: '45vh',
      maxHeight: '45vh'
    };
    if (showPromo && _index === 0) {
      return /*#__PURE__*/_react["default"].createElement(_PromoItem.PromoContainer, {
        style: style
      }, promo);
    }
    return cellRenderer({
      index: index,
      data: data,
      style: style
    });
  }, [promo, showPromo]);
  var items = (0, _react.useMemo)(function () {
    if (data.length) {
      var placeholder = [];
      if (showPromo) placeholder = [PLACEHOLDER_PROMO];
      var res = [].concat((0, _toConsumableArray2["default"])(placeholder), (0, _toConsumableArray2["default"])(data));
      if (total > data.length) {
        return res.concat(
        // Placeholder for empty data
        new Array(total - data.length).fill({}));
      }
      return res;
    }
    return [];
  }, [shouldUpdateCache, data, total, showPromo]);
  (0, _react.useEffect)(function () {
    return function () {
      onScroll({
        scrollTop: 0
      });
    };
  }, []);
  (0, _react.useEffect)(function () {
    var scroller = listRef.current;
    if (typeof scrollToIndex === 'number' && scroller) {
      scroller.scrollTo({
        top: scrollToIndex
      });
    }
  }, [scrollToIndex]);
  (0, _react.useEffect)(function () {
    onScroll({
      scrollTop: scrollTop
    });
  }, [isScrolling]);
  var children = (0, _masonic.useMasonry)({
    id: 'masonry',
    items: items,
    height: height,
    itemKey: itemKey,
    scrollTop: scrollTop,
    positioner: positioner,
    isScrolling: isScrolling,
    resizeObserver: resizeObserver,
    onRender: onLoadMore,
    overscanBy: overscan,
    render: RenderComponent
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "max-w-screen-xl mx-auto p-8"
  }, children, isLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    fullWidth: true
  })), footer ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: Math.max(MIN_FOOTER_HEIGHT, innerHeight ? height - innerHeight : 0),
      alignItems: 'center',
      display: 'flex'
    }
  }, footer) : null);
};
var _default = exports["default"] = ThreadFeedList;
//# sourceMappingURL=index.js.map